export const NAME = 'fdeInbox';
